export default {
  login: {
    title: '账号登录',
    logIn: '登录',
    account: '账号',
    password: '密码',
    accountTips: '请输入登录账号！',
    passwordTips: '请输入登录密码！'
  },
  navbar: {
    dashboard: '首页',
    logOut: '退出登录',
    editPassword: '修改密码',
    uploadClient: '上传客户端',
    downloadClient: '下载客户端',
    modal: {
      uploadClientModal: {
        title: '上传客户端',
        content: {
          form: {
            clientProgram: "客户端程序",
            productName: "产品名称"
          },
          formRules: {
            productName: "请输入名称"
          },
        },
        footerBtn: {
          cancle: '取消',
          confirm: '确定',
        },
        tips: {
          fileTips: '将文件拖到此处，或点击上传',
          fileEmptyTips: "请先选择要上传的文件！",
          exceedTips: "当前限制选择 1 个文件，本次选择了 {count} 个文件"
        }
      },
      downloadClientModal: {
        title: '下载客户端',
        content: {
          downloadFileSelection: "下载文件选择",
          placeholder: '请选择',
          fileOptionsDel: "删除"
        },
        footerBtn: {
          download: '下载',
        },
        tips: {
          fileEmptyTips: "请选择下载文件！",
          delTipsTitle: '提示',
          delTipsContent: "此操作将删除该客户端, 是否继续?",
          cancleTips: "已取消删除",
          delTipsCancle: '取消',
          delTipsConfirm: '确定',
        }
      },
      editPasswordModal: {
        title: '个人密码设置',
        content: {
          form: {
            originalPassword: "旧密码",
            newPassword: "新密码",
            confirmPassword: "确认密码",
          },
          formRules: {
            originalPassword: "请输入旧密码",
            newPassword: "请输入新密码",
            confirmPassword1: "请输入确认密码",
            confirmPassword2: "两次密码请保持一致"
          },
        },
        footerBtn: {
          cancle: '取消',
          confirm: '确定',
        },
        tips: {
          fileTips: '将文件拖到此处，或点击上传',
          fileEmptyTips: "请先选择要上传的文件！",
          setPasswordTipsTitle: "系统提示"
        }
      },
    }
  },
  pages: {
    ruleManage: {
      search: {
        placeholder: "请输入规则名称"
      },
      tableHeader: {
        entryName: "规则名称",
        entryIdentification: "规则标识",
        checkType: "审查方式",
        checkLeave: "级别",
        weldingType: "审查人员",
        ruleValue: "设计参数",
        designatedArea: "参数说明",
        operate: "操作",
      },
      btn: {
        treeMenuBtn: {
          edit: "修改",
          delete: "删除",
          addSubordinate: "添加下级",
          upgrade: "升级",
          copy: "复制",
          history: "历史",
        },
        tableBtn: {
          headerBtn: {
            advancedSearch: "高级搜索",
            moveEntries: "移动条目",
            addEntries: "增加条目",
            batchDeletion: "批量删除",
            importEntries: "导入条目",
            exportEntries: "导出条目",
            exportAllEntries: "导出全部条目",
            exportCategoryEntries: "导出分类条目",
            exportRuleGroupEntries: "导出规则组条目",
            exportCheckedEntries: "导出勾选条目",
          },
          operateBtn: {
            edit: '编辑',
            copy: '复制',
            delete: '删除'
          }
        }
      },
      modal: {
        addRuleClassModal: {
          title: '添加规则类',
          editTitle: '编辑规则类',
          content: {
            form: {
              className: "类名称",
              version: "版本号",
              remark: "备注",
            },
            formRules: {
              className: "请输入类名称",
              version: "请输入版本号",
              roleRevise: "请输入规则版本"
            },
            placeholder: {
              className: "请输入类名称，最多不超过50字",
              version: "请输入版本号",
              remark: "请输入规则描述，最多不超过100字",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            roleNameEmptyTips: "请填写规则信息！",
            remarkTextTips: "还可输入 {count}字",
            versionTips: "新版本号应大于旧版本号"
          }
        },
        upgradeModal: {
          title: '请输入升级后的版本号',
          content: {
            form: {
              version: "版本号",
            },
            placeholder: {
              version: "请输入版本号",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            versionTips1: "当前版本号：",
            versionTips2: "您应输入大于当前版本号的合法数字作为新版本号",
            versionEmptyTips: "版本号不能为空",
          }
        },
        copyRuleModal: {
          title: '复制规则类',
          content: {
            form: {
              newClassName: "新类名称",
              version: "版本号",
            },
            formRules: {
              newClassName: "请输入类名称",
            },
            placeholder: {
              newClassName: "请输入类名称，最多不超过50字",
              version: "版本号",
            }
          },
          footerBtn: {
            confirm: '确定',
          },
          tips: {
            versionTips1: "规则名和版本号不能为空",
          }
        },
        historicVersionModal: {
          title: "规则历史版本",
          historicalVersionsTitle: "历史版本高级搜索",
        },
        treeMenuEditModal: {
          title: '添加/修改规则组',
          content: {
            form: {
              roleName: "组名称",
              remark: "备注"
            },
            formRules: {
              roleName: "请输入组名称"
            },
            placeholder: {
              roleName: '请输入组名称，最多不超过50字',
              remark: "请输入组描述，最多不超过100字"
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            roleNameEmptyTips: "请填写规则信息！",
            remarkTextTips: "还可输入 {count}字"
          }
        },
        advancedSearchModal: {
          title: '高级搜索',
          content: {
            addSearchCriteria: "添加搜索条件",
            valuePlaceholder: "请输入",
            searchConditionsOption1: '规则名称',
            searchConditionsOption2: '规则标识',
            searchConditionsOption3: '审查方式',
            searchConditionsOption4: '级别',
            searchConditionsOption5: '审查人员',
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            searchConditionErrTips: "请填写完整的搜索条件！",
            searchExistsTips: '高级搜索弹窗中，已经输入了检索条件!'
          }
        },
        moveEntriesModal: {
          title: '请选择要移动到的位置',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            emptyCategoryTips: "请选择要移动到的类别!",
            sameCategoryTips: '要移动的分类和当前分类相同,无需移动',
          }
        },
        addEntriesModal: {
          title: '规则添加/编辑',
          content: {
            form: {
              entryName: "规则名称",
              entryIdentification: "规则标识",
              ruleGroup: "规则组",
              checkType: "审查方式",
              checkLeave: "级别",
              weldingType: "审查人员",
              ruleValue: "设计参数",
              designatedArea: "参数说明",
              remark: "规则说明",
            },
            formRules: {
              entryName: "请输入规则名称",
              entryIdentification: "请输入规则标识",
              checkType: "请选择审查方式",
              checkLeave: "请选择级别",
              weldingType: "请选择审查人员",
            },
            placeholder: {
              entryName: "请输入规则名称",
              entryIdentification: "请输入规则标识",
              checkType: "请选择审查方式",
              checkLeave: "请选择级别",
              weldingType: "请选择审查人员",
              ruleValue: "请输入设计参数",
              designatedArea: "请输入参数说明",
              remark: "请输入规则描述，不能超过1000字",
            },
            btn: {
              selectRuleImage: "选择规则图片",
              clickToUpload: "点击上传",
              selectRuleDocument: "选择规则文档"
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            ruleValueTips: "只可输入： 字母、数字、英文逗号、英文分号英文冒号、英文点号、中划线、下划线，最多可输入1000字哦",
            designatedAreaTips: "最多可输入1000字噢",
            selectRuleImageTips: "只能上传jpg/png/gif文件，只允许选择1张图片",
            remarkTextTips: "还可输入 {count} 字",
            entryIdentificationTips: "自动审查方式下必填,人工下选填",
            notAllowedToUploadTips: '不允许上传',
            perfectInformationTips: "请先完善好信息",
            selLastNodeTips: "请先选择某个最末级节点"
          },
        },
        selectRuleDocumentModal: {
          title: '选择要上传的文件',
          content: {
            searchPlaceholder: "请输入文件名称",
            tableHeader: {
              fileName: "文件名称",
              fileSize: "文件大小",
              userName: "上传人",
              updateTime: "上传时间",
            },
            btn: {
              uploadFile: "上传文件",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            emptyFileTips: "请先选择文件",
          },
        },
        uploadFileModal: {
          title: '选择要上传的文件',
          titlePreview: "预览",
          content: {
            btn: {
              uploadFile: "点击选择文件",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定上传',
          },
          tips: {
            limitFileNumTips: "单次最多可上传10个文件",
            notAllowedToUploadTips: '不允许上传',
            emptyFileTips: "请先选择文件",
          },
        },
        batchDelModal: {
          title: '提示',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            delTips: "被勾选规则条目将被删除, 是否继续?",
            cancleTips: "已取消删除"
          },
        },
        importEntriesModal: {
          title: '导入条目',
          content: {
            btn: {
              downloadTemplate: "立即下载《知识库导入数据模板》",
            }
          },
          footerBtn: {
            confirm: '确定上传',
          },
          tips: {
            emptyFileTips: "请选择文件",
            uploadTips: " 将文件拖到此处，或 点击上传",
            stepsTips: "操作步骤：",
            stepsTips1: "下载《知识库导入数据模板》",
            stepsTips2: "打开下载表，将对应字段信息输入或粘贴进本表。为保障粘贴信息被有效导入，请使用纯文本或数字",
            stepsTips3: "信息输入完毕，点击 “点击上传” 按钮， 选择excel文档",
            stepsTips4: "点击 “确定上传”",
          },
        },
        delRuleModal: {
          title: '提示',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            delTips: "该规则条目将被删除, 是否继续?",
            cancleTips: "已取消删除"
          },
        },
      },
      tips: {
        emptyMoveRuleEntryTips: "请先选择要移动的规则条目",
        emptyDelRuleEntryTips: "请先选择需要删除的规则条目",
        perfectInformationTips: "请先完善好信息",
        emptyCheckItemsTips: "请先选择导出的条目！",
        emptyRuleGroupTips: "请先选择规则组！",
        ruleDescriptionTips: "说明："
      },
      tabs: {
        ruleDescription: "规则说明",
        rulesDocumentation: "规则文档",
      }
    },
    entryMaintenance: {
      tableHeader: {
        value: "值",
        createTime: "创建时间",
        remark: "备注",
        operate: "操作",
      },
      btn: {
        tableBtn: {
          headerBtn: {
            addNewConfigurationItems: "新增配置项",
          },
          operateBtn: {
            edit: '修改',
            delete: '删除'
          }
        }
      },
      modal: {
        updateNewConfigurationItemsModal: {
          addTitle: '新增配置项',
          editTitle: '修改维护项',
          content: {
            form: {
              configuration: "配置项",
              inputValue: "输入值",
              remark: "备注"
            },
            placeholder: {
              configuration: "配置项",
              inputValue: "输入值",
              remark: "备注"
            },
            options: {
              configurationitemsOption1: '审查人员',
              configurationitemsOption2: '审查方式',
              configurationitemsOption3: '审查级别',
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            perfectInformationTips: "请先完善好信息",
            remarkTextTips: "还可输入 {count} 个字",
            unmodifiedTips: '并未修改，就不要确定了'
          }
        },
      },
      tabs: {
        censors: "审查人员",
        censorshipMethod: "审查方式",
        censorshipLevel: "审查级别",
      }
    },
    modelFile: {
      search: {
        placeholder: "请输入文件名称"
      },
      tableHeader: {
        fileName: "文件名称",
        fileSize: "文件大小",
        userName: "上传人",
        updateTime: "上传时间",
        operate: "操作",
      },
      btn: {
        tableBtn: {
          headerBtn: {
            uploadFile: "上传文件",
          },
          operateBtn: {
            download: '下载',
            delete: '删除'
          }
        }
      },
      modal: {
        uploadFileModal: {
          title: '选择要上传的文件',
          content: {
            btn: {
              uploadFile: "点击选择文件",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定上传',
          },
          tips: {
            emptyFileTips: "请先选择要上传的文件",
            limitFileNumTips: "单次最多可上传10个文件",
          },
        },
        repeatFileUploadModal: {
          title: '提示',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            delTips: "系统检测到文件 {fileName} 已存在，是否更新?",
            cancleTips: "已取消更新"
          },
        },
      },
      tabs: {
        censors: "审查人员",
        censorshipMethod: "审查方式",
        censorshipLevel: "审查级别",
      }
    },
    employeesManage: {
      search: {
        rolePlaceholder: "请选择",
        keywordPlaceholder: "姓名",
        accountLikePlaceholder: "登录账号",
        staffNoLikePlaceholder: "工号",
        emailLikePlaceholder: "邮箱",
        addressLikePlaceholder: "办公地址",
        options: {
          roleOption1: "全部用户",
          roleOption2: "普通用户",
          roleOption3: "系统管理员",
        }
      },
      tableHeader: {
        index: "序号",
        userName: "姓名",
        account: "登录账号",
        userType: "账号类型",
        staffNo: "工号",
        sex: "性别",
        postName: "岗位",
        secretLevelName: "密级",
        deptName: "主属部门",
        position: "职称",
        officeAddress: "办公地址",
        phone: "手机号",
        email: "邮箱",
        idCard: "身份证号码",
        enable: "是否启用",
        operate: "操作",
      },
      tableCol: {
        sex: {
          value1: '男',
          value2: '女',
          value3: '未知'
        }
      },
      btn: {
        treeMenuBtn: {
          addSubordinate: "新建下级",
          addLevel: "新建平级",
          edit: "编辑",
          delete: "删除",
        },
        tableBtn: {
          headerBtn: {
            changeDepartment: "换部门",
            addEmployee: "添加员工",
            more: "更多",
            importEmployeeInformation: "导入员工信息",
            exportEmployeeInformation: "导出员工信息",
          },
          operateBtn: {
            edit: '编辑',
            role: '角色',
            resetPassword: '重置密码',
            loginIsProhibited: '禁止登录',
            allowLogin: '允许登录',
            deactivate: '停用',
            enable: '启用',
          }
        }
      },
      modal: {
        updateDepartmentModal: {
          title: '部门',
          content: {
            form: {
              deptName: "部门名称",
              superiorDepartment: "上级部门",
              leadingOfficial: "部门负责人",
              departmentNumber: "部门编号",
            },
            formRules: {
              deptName: "请输入部门名称",
              deptName1: "长度在 2 到 20 个字符",
              superiorDepartment: "请选择上级部门",
              leadingOfficial: "请添加部门负责人",
            },
            placeholder: {
              roleName: '请输入组名称，最多不超过50字',
              remark: "请输入组描述，最多不超过100字",
              superiorDepartment: "请选择上级部门",
              leadingOfficial: '请添加部门负责人'
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            leadingOfficialTips: "部门负责人为部门管理者，数据系统、销售报表等均可按照设置后部门负责人统计",
            emptyLeadingOfficialTips: "请选择部门负责人",
          }
        },
        changeDepartmentModal: {
          title: '移动部门',
          content: {
            placeholder: "部门"
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          }
        },
        updateEmployeeModal: {
          title: '员工',
          content: {
            accountInformatioTitle: "账号信息",
            organizationalRelationshipsTitle: "组织关系",
            personalInformationTitle: "个人信息",
            form: {
              account: "登录账号",
              userName: "姓名",
              userType: "账号类型",
              staffNo: "工号",
              sex: "性别",
              post: "岗位",
              secretLevel: "密级",
              mainDepartment: "主属部门",
              officeAddress: "办公地址",
              phone: "手机号",
              idCard: "身份证号码",
              affiliatedDepartments: "附属部门",
              position: "职称",
              entryTime: "入职日期",
              birthday: "生日",
              email: "邮箱",
            },
            formRules: {
              account: "请输入登录账号",
              userName: "请输入姓名",
              email: "请输入合法的email"
            },
            placeholder: {
              account: "登录账号是员工在企业的唯一标识，请勿重复",
              userName: "请输入姓名",
              staffNo: "请输入工号",
              post: "请选择岗位",
              secretLevel: "请输入密级",
              officeAddress: "请输入办公地址",
              phone: "请输入手机号",
              idCard: "请输入身份证号",
              position: "请输入职称",
              entryTime: "请选择入职日期",
              birthday: "选择日期",
              email: "请输入邮箱",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '保存',
            saveAndContinueAdding: '保存并继续添加',
          },
          tips: {
            accountCheckTips: "账号长度必须3-20位",
            mainDepartmentTips: "请先选择主属部门",
            phoneErrorTips: "请输入合法的手机号",
            emailErrorTips: "请输入合法的邮箱",
            idCardErrorTips: "请输入合法的身份证号码",
          }
        },
        importEmployeeInformationTipsModal: {
          title: '提示',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: "未选择部门 , 默认到无部门人员下"
        },
        importEmployeeInformationModal: {
          title: '导入员工信息',
          content: {
            btn: {
              downloadTemplate: "立即下载《用户批量导入模板》",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            updateTips: " 注：请勾选需要导入字段（默认导入全部）",
            uploadTips: " 将文件拖到此处，或 点击上传",
            stepsTips: "操作步骤：",
            stepsTips1: "下载《用户批量导入模板》",
            stepsTips2: "打开下载表，将对应字段信息输入或粘贴进本表。为保障粘贴信息被有效导入，请使用纯文本或数字",
            stepsTips3: "信息输入完毕，点击 “点击上传” 按钮， 选择excel文档",
            stepsTips4: "点击 “确认",
            uploadErrorTips: "上传信息提示",
            uploadAccountError1Tips: "第{row}行第{col}列登录账号不能为空，请检查",
            uploadAccountError2Tips: "第{row}行第{col}列登录账号必须为3-20位，请检查",
            uploadAccountError3Tips: "第{row}行第{col}列登录账号不能为中文，请检查",
            uploadUserNameErrorTips: "第{row}行第{col}列姓名不能为空，请检查",
            uploadGenderErrorTips: "第{row}行第{col}列性别格式错误，请检查",
            uploadPhoneErrorTips: "第{row}行第{col}列手机号格式错误，请检查",
            uploadEmailErrorTips: "第{row}行第{col}列邮箱格式错误，请检查",
            uploadIDcardErrorTips: "第{row}行第{col}列身份证号码格式错误，请检查",
            uploadBirthdayErrorTips: "第{row}行第{col}列出生日期格式错误，请检查",
          },
        },
        roleModal: {
          title: '设置角色',
          content: {
            roleTitle: "角色",
            haveTitle: "拥有",
            placeholder: "请输入搜索内容"
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
        },
        resetPasswordModal: {
          title: '重置密码',
          content: {
            placeholder: "重置后的密码"
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            emptyTip: "重置密码不能为空",
          }
        },
        loginBinOrPassTipsModal: {
          title: '提示',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            binTips: "确定要禁止该账号登录吗？",
            passTips: "确定要允许该账号登录吗？",
          }
        },
        accountStopOrStartTipsModal: {
          title: '提示',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            stopTips: "确定要禁用该账号吗？",
            startTips: "确定要启用该账号吗？",
          }
        },
      },
      tips: {
        allDepartment: "所有部门",
        noDepartment: '暂无部门请点击添加',
        sameDepartmentTips: "附属部门不能和主属部门一致"
      }
    },
    roleManage: {
      search: {
        placeholder: "角色名称",
        searchBtn: "查询"
      },
      tableHeader: {
        index: "序号",
        userName: "角色名称",
        remark: "简介",
        roleType: "类型",
        operate: "操作",
      },
      tableCol: {
        roleType: {
          value1: "业务角色",
          value2: "管理角色",
          value3: "系统内置角色",
        }
      },
      btn: {
        tableBtn: {
          headerBtn: {
            add: "添加",
          },
          operateBtn: {
            check: '查看',
            permissions: '权限',
            functionButtons: '功能按钮',
            delete: '删除',
            selectPeople: '选择人员',
          }
        }
      },
      modal: {
        addAndCheckModal: {
          title: '角色',
          content: {
            form: {
              roleName: "角色名称",
              remark: "简介",
              sortNo: "相关人员",
            },
            formRules: {
              roleName: "请输入角色名称",
              roleName1: "长度在 2 到 15 个字符"
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          }
        },
        permissionsModal: {
          title: '为{name}工分配菜单',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: {
            emptyTips: "如果用户没有一个菜单是无法进入本系统的,请保留至少一个菜单",
            setPasswordTipsTitle: "系统提示"
          }
        },
        functionButtonsModal: {
          title: '为{name}分配按钮权限',
          content: {
            btn: {
              allSelect: "全选",
              cancleAllSelect: "取消全选",
            }
          },
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          }
        },
        delTipsModal: {
          title: '提示',
          footerBtn: {
            cancle: '取消',
            confirm: '确定',
          },
          tips: "此操作将永久删除, 是否继续?"
        },
        selectPeopleModal: {
          title: '为技术工选择人员',
          content: {
            searchPlaceholder: "请输入员工姓名",
            allSelect: "全选",
          },
          footerBtn: {
            confirm: '保存',
          },
          tips: "此操作将永久删除, 是否继续?"
        }
      },
    },
    analysisPage: {
      search: {
        symbolPlaceholder: "请选择图号",
        versionvaluePlaceholder: "请选择版本号",
        cishuvaluePlaceholder: "请选择次数"
      },
      echarts: {
        title1: "规则检查质量统计",
        title2: "规则检查频次统计",
        toolbox: {
          dataView: '数据视图',
          magicType1: '切换为折线图',
          magicType2: '切换为柱状图',
          restore: '还原',
          saveAsImage: '保存为图片',
          close: '关闭',
          refresh: '刷新',
        }
      },
      tips: {
        normal: "正常",
        notChecked: "未查",
        error: "有误",
      }
    },
    // 数据手册
    datasheet: {
      search: {
        placeholder: "请按数据手册名称和制造商名称进行检索",
        treePlaceholder: "请输入搜索内容",
        selectPlaceholder: "状态",
        released: "正式",
        temporary: "临时",
        pending: "流程中",
      },
      tableHeader: {
        categoryName: "分类名称",
        manualName: "数据手册",
        manufacturersName: "制造商",
        status: "状态",
        createTime: "上传时间",
        userName: "上传人",
        description: "说明",
        remark: "备注",
        operate: "操作",
      },
      btn: {
        treeBtn: {
          AddFirstLevelClassification: "新增一级分类",
          viewAll: "查看全部",
        },
        treeMenuBtn: {
          edit: "修改分类",
          delete: "删除分类",
          addSubordinate: "添加分类",
        },
        tableBtn: {
          headerBtn: {
            updateAll: "更新全部手册的制造商",
            upload: "上传数据手册",
            move: "移动手册分类",
            recycleBin: "回收站",
          },
          operateBtn: {
            update: '更新制造商',
            preview: '预览',
            edit: '编辑',
            historicVersion: '历史版本',
            delete: '删除'
          }
        }
      },
      modal: {
        updateCategory: {
          title: '添加分类',
          editTitle: '编辑',
          content: {
            form: {
              categoryName: "分类名称",
            },
            placeholder: {
              categoryName: "请输入分类名称",
            }
          },
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
          tips: {
            categoryNameEmptyTips: "分类名称不能为空！",
          }
        },
        updateManual: {
          title: '上传数据手册',
          editTitle: '编辑',
          content: {
            form: {
              manufacturer: "制造商",
              classification: "分类",
              status: "状态",
              description: "说明",
              manualName: "名称",
              inputVersion: "录入版本号",
              // description: "描述",
              changeDescription: "更改说明",
              remark: "备注",
            },
            placeholder: {
              manufacturer: "请选择制造商",
              classification: "请选择分类",
              description: "请输入说明",
            },
            options: {
              statusOption1: '正式',
              statusOption2: '临时',
            }
          },
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
          tips: {
            fileEmptyTips: "请先选择要上传的数据手册",
            classificationEmptyTips: "请选择分类！",
            addManufacturerTips: "点击添加制造商",
            uploadTips: "上传数据手册",
            fileSizeLimitTips: "单个文件大小不超过200M",
            fileTotalSizeLimitTips: "文件总大小超过200M，请重新选择上传文件",
            fileNumberLimitTips: "当前限制选择 100 个文件，本次选择了 { length1 } 个文件，共选择了 { length2 } 个文件",
            removefileTips: "确定移除 { name }？",
            fileWithTheSameNameTips: "不能选择同名文件",
          }
        },
        duplicateFiles: {
          title: '更新',
          tableHeader: {
            manualName: "数据手册",
            manufacturersName: "制造商",
            status: "状态",
            createTime: "上传时间",
            description: "说明",
          },
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
        },
        duplicateFilesPrompt: {
          title: '提示',
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
          tips: {
            delTips: "文件 { tipInfo } 已存在  是否更新",
            cancelTips: "已取消更新"
          },
        },
        addManufacturer: {
          title: '制造商',
          content: {
            form: {
              name: "公司名称",
              abbreviation: "公司简称",
              differentCountries: "地址",
              website: "网址",
              phone: "联系方式",
              fax: "传真",
              email: "邮箱",
              oldName: "历史曾用名",
              intro: "公司简介",
              remark: "备注",
              logo: "Logo",
            },
            formRules: {
              name: "请输入公司名称",
              abbreviation: "请输入公司简称",
              email: "长度在 7 到 200 个字符",
            },
          },
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
          tips: {
            logoTips: "只能上传jpg/png文件",
            websiteTips: "请输入合法网址",
            phoneTips: "请输入合法手机号",
            faxTips: "传真格式不符合规范",
            emailTips: "请输入合法邮箱",
          }
        },
        moveClassificationManual: {
          title: "移动分类手册",
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
          tips: {
            emptyClassificationTips: "请选择目标分类！",
          }
        },
        recycleBinModal: {
          title: '回收站',
          search: {
            placeholder: "请按数据手册名称和制造商名称进行检索",
          },
          content: {
            tableHeader: {
              categoryName: "分类",
              manualName: "数据手册",
              manufacturersName: "制造商",
              status: "状态",
              userName: "上传人",
              createTime: "上传时间",
              updateTime: "删除时间",
              operate: "操作",
            },
            btn: {
              tableBtn: {
                headerBtn: {
                  delete: "删除 ",
                },
                operateBtn: {
                  historyRecord: '历史记录',
                  recover: '恢复',
                  preview: '预览',
                }
              }
            },
          },
          tips: {
            manualEmptyTips: "请先选择数据手册!",
          }
        },
        renameModal: {
          content: {
            placeholder: {
              name: "请输入文件名称",
            },
            btn: {
              rename: "重命名",
              revertToHistory: "恢复成历史记录",
            },
          },
          footerBtn: {
            confirm: '确定',
          },
          tips: {
            nameEmptyTips: "名称不能为空！",
          }
        },
        historicVersion: {
          title: '历史版本',
          content: {
            tableHeader: {
              manualName: "数据手册",
              versionNumber: "版本号",
              status: "状态",
              userName: "上传人",
              createTime: "上传时间",
              operate: "操作",
            },
            btn: {
              tableBtn: {
                operateBtn: {
                  preview: '预览',
                }
              }
            },
          },
        },
        deletePrompt: {
          title: '提示',
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
          tips: {
            delTips: "是否确定删除该手册?",
            cancelTips: "已取消删除"
          },
        },
        updateCanclePrompt: {
          title: '提示',
          footerBtn: {
            cancel: '取消',
            confirm: '确定',
          },
          tips: {
            delTips: "是否确定取消?",
            cancelTips: "已取消删除"
          },
        },
      },
      tips: {
        manualEmptyTips: "该手册不存在！",
      },
    },
    404: {
      content: {
        text1: "请检查您输入的网址是否正确，请点击以下按钮返回",
        text2: "主页或者发送错误报告",
        backHomeBtn: "返回首页",
      }
    }
  }
}
